
export const mainColor700 =  "#303f9f"; // #00796b;
export const mainColor600 = "#3949ab"; // #00897B;
export const mainColor400 = "#5c6bc0"; // #26a69a
export const mainColor100 = "#c5cae9"; // #B2DFDB
export const mainColor900 = "#1a237e";  // "#004d40";
